const LOGIN_RETURN_TO_KEY = 'campuslush.loginReturnTo';

const BLOCKED_PREFIXES = ['/login', '/signup', '/saml', '/auth', '/reset-password'];

export function isSafeReturnTo(path: unknown): path is string {
  if (typeof path !== 'string' || !path) return false;
  if (!path.startsWith('/')) return false;
  if (path.startsWith('//')) return false;
  if (path.includes('\\')) return false;
  if (/^[a-zA-Z][a-zA-Z0-9+.-]*:/.test(path)) return false;
  return true;
}

export function shouldPreservePath(path: string): boolean {
  return isSafeReturnTo(path) && !BLOCKED_PREFIXES.some((prefix) => path === prefix || path.startsWith(`${prefix}?`) || path.startsWith(`${prefix}/`));
}

export function captureLoginReturnTo(next: unknown): string | null {
  const value = Array.isArray(next) ? next[0] : next;
  if (!isSafeReturnTo(value) || !shouldPreservePath(value)) return null;
  if (typeof window !== 'undefined') {
    window.sessionStorage.setItem(LOGIN_RETURN_TO_KEY, value);
  }
  return value;
}

export function peekLoginReturnTo(): string | null {
  if (typeof window === 'undefined') return null;
  const stored = window.sessionStorage.getItem(LOGIN_RETURN_TO_KEY);
  return isSafeReturnTo(stored) ? stored : null;
}

export function consumeLoginReturnTo(): string {
  const stored = peekLoginReturnTo();
  if (typeof window !== 'undefined') {
    window.sessionStorage.removeItem(LOGIN_RETURN_TO_KEY);
  }
  return stored || '/';
}

export function loginPath(next?: string): string {
  if (next && shouldPreservePath(next)) {
    return `/login?next=${encodeURIComponent(next)}`;
  }
  return '/login';
}
